export default __webpack_public_path__ + "static/media/14.9de0c635.svg";